import pluralize from 'pluralize'
import {TextInput} from '@primer/react'
import type {EditablePreview} from '../types'
import {useUpdatePreviews} from '../contexts/UpdatePreviewsContext'

export type PreviewProps = {
  preview: EditablePreview
}

export function Preview({preview}: PreviewProps) {
  const {setRulesetName} = useUpdatePreviews()
  const rulesetCount = preview.rulesets.length

  if (preview.isFullyCovered) {
    return <i className="color-fg-muted">Already covered by an existing ruleset</i>
  }
  if (rulesetCount === 0) {
    return <i className="color-fg-muted">No rulesets would be created</i>
  }

  const hasGaps = (preview.gaps?.length ?? 0) > 0

  return (
    <div className="d-flex flex-column gap-1 width-full">
      <span className="color-fg-muted">
        {rulesetCount} {pluralize('ruleset', rulesetCount)}
      </span>
      {preview.rulesets.map((ruleset, index) => (
        <TextInput
          block
          value={ruleset.name}
          key={ruleset.title}
          aria-label={`Ruleset name for ${ruleset.title}`}
          onChange={ev => {
            setRulesetName({
              id: preview.id,
              rulesetIndex: index,
              newRulesetName: ev.target.value,
            })
          }}
        />
      ))}
      {preview.requiresConversationResolution && (
        <div className="color-bg-subtle border rounded-2 px-3 py-2">
          <strong>Require conversation resolution:</strong> In rulesets, requiring conversation resolution also requires
          a pull request. Comment resolution itself works the same, except you can&apos;t bypass it by merging without a
          pull request.
        </div>
      )}
      {hasGaps && (
        <ul className="list-style-none">
          {preview.gaps?.map(gap => (
            <li key={gap} style={{maxWidth: 300}}>
              <i className="color-fg-muted">{gap}</i>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
